module.exports = __webpack_public_path__ + "static/media/third-prize.03839ade.png";